import { Field, FieldType, TopicTypeId } from '@app/origami-api/constants';
import { ConfigServiceModel } from '@app/origami-api/services/config.service';

export const getFormFieldType = ({
  Flags,
  Options,
}: Pick<ConfigServiceModel.Field, 'Flags' | 'Options'>): FieldType => {
  const isRadio = Field.Is.radio(Flags);
  const isCheckBox = Field.Is.checkBox(Flags);
  const isComboBox = Field.Is.dropDown(Flags);

  if (Field.Is.richText(Flags)) {
    return FieldType.RichText;
  }

  if (Field.Is.user(Flags)) {
    return FieldType.User;
  }

  if (Field.Is.topic(Flags)) {
    const topicTypeId = Options?.ValueTopicTypeId;
    switch (topicTypeId) {
      case TopicTypeId.Contact:
        return FieldType.Contact;
    }
  }

  if (isRadio || isCheckBox || isComboBox) {
    return Field.Is.boolean(Flags) ? FieldType.Boolean : FieldType.KeywordLookup; // We don't have separate bit for keyword lookup. Assuming all other fields are keyword lookups.
  }

  if (Field.Is.text(Flags)) {
    return FieldType.Text;
  }
  if (Field.Is.textArea(Flags)) {
    return FieldType.LongText;
  }
  if (Field.Is.number(Flags)) {
    return FieldType.Number;
  }
  if (Field.Is.date(Flags)) {
    return FieldType.Date;
  }

  // nothing matched, let's check if this is some system boolean only-for-internal-logic field
  if (Field.Is.boolean(Flags)) {
    return FieldType.Boolean;
  }

  // falling back to the text field
  return FieldType.Text;
};
